import * as THREE from 'three'
import { useState, useRef, useEffect } from 'react'
import { Canvas, useFrame, useLoader } from '@react-three/fiber'
import { Html, OrbitControls, Environment, ContactShadows, Select } from '@react-three/drei'
import { FaMapMarkerAlt } from 'react-icons/fa'

function degreesToRadians(degrees) {
  return degrees * (Math.PI / 180);
}

function Model(props) {
  const colorMap = useLoader(THREE.TextureLoader, '/8k_earth_daymap.jpg')

  return (
    <group {...props} dispose={null}>
      <mesh castShadow receiveShadow rotation={[0, 0, 0]}>
        <sphereGeometry args={props.globeSize} />
        <meshStandardMaterial map={colorMap} />
      </mesh>

      <mesh>
        <Marker scale={props.selectedVal == 3 ? 1 : 0.4} rotation={[0.3, 160, 0]} position={[0.3, 0.5218, -0.8360]}>
          <div style={{ position: 'absolute', fontSize: '3px', fontWeight: 'bolder', letterSpacing: 0, lineHeight: 1.15, left: 8, top: 9, color: "white" }}>
            Karachi, Pakistan
          </div>
          <FaMapMarkerAlt size={6} style={{ color: '#4b93ff' }} />
        </Marker>
        <Marker scale={props.selectedVal == 1 ? 1 : 0.4} rotation={[0, 0, 0]} position={[-0.2, 0.75, 0.9]}>
          <div style={{ userSelect: 'none', position: 'absolute', fontSize: '3px', fontWeight: 'bolder', letterSpacing: 0, lineHeight: 1.15, left: 8, top: 9, color: "white" }}>
            Illinois USA
          </div>
          <FaMapMarkerAlt size={6} style={{ color: '#4b93ff' }} />
        </Marker>
        <Marker scale={props.selectedVal == 2 ? 1 : 0.4} rotation={[0, degreesToRadians(145), 0]} position={[0.60, 0.6118, -0.7360]}>
          <div style={{ userSelect: 'none', position: 'absolute', fontSize: '3px', fontWeight: 'bolder', letterSpacing: 0, lineHeight: 1.15, left: 8, top: 9, color: "white" }}>
            UAE Dubai
          </div>
          <FaMapMarkerAlt size={6} style={{ color: '#4b93ff' }} />
        </Marker>
      </mesh>
    </group>
  )
}

function Marker({ children, ...props }) {
  const ref = useRef()
  const [isOccluded, setOccluded] = useState()
  const [isInRange, setInRange] = useState()
  const isVisible = isInRange && !isOccluded
  const vec = new THREE.Vector3()
  useFrame((state) => {
    const range = state.camera.position.distanceTo(ref.current.getWorldPosition(vec)) <= 10
    if (range !== isInRange) setInRange(range)
  })
  return (
    <group ref={ref}>
      <Html
        transform
        occlude
        onOcclude={setOccluded}
        style={{ transition: 'all 0.2s', opacity: isVisible ? 1 : 0, transform: `scale(${isVisible ? 1 : 0.25})` }}
        {...props}>
        {children}
      </Html>
    </group>
  )
}

function CustomOrbitalControl({ azAngle, plAngle }) {
  const orbRef = useRef(null)

  useFrame(() => {
    if (orbRef.current) {
      orbRef.current.setAzimuthalAngle(azAngle)
      orbRef.current.setPolarAngle(plAngle)
    }
  })

  return <OrbitControls ref={orbRef} enableZoom={false} enablePan={true} />
}

export default function Viewer() {
  const [earthazAngle, setEarthazAngle] = useState(THREE.MathUtils.degToRad(355))
  const [earthplAngle, setEarthplAngle] = useState(THREE.MathUtils.degToRad(90))
  const [selectedVal, setSelectedVal] = useState(1)
  const [globeSize, setGlobeSize] = useState([1, 64, 32]) // Default globe size
  const [cameraFov, setCameraFov] = useState(35) // Default FOV

  const handleRotation = (az, pl, sl) => {
    setEarthazAngle(THREE.MathUtils.degToRad(az))
    setEarthplAngle(THREE.MathUtils.degToRad(pl))
    setSelectedVal(sl)
  }

  useEffect(() => {
    handleRotation(355, 60, 1)

    // Responsive adjustment
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setGlobeSize([1, 64, 32]) // Smaller globe for mobile
        setCameraFov(52) // Set FOV to 50 for mobile
      } else {
        setGlobeSize([1, 64, 32]) // Default size for larger screens
        setCameraFov(35) // Set FOV to 35 for desktop
      }
    }

    window.addEventListener('resize', handleResize)
    handleResize() // Call once to set initial state
    

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <>
    
      <div style={{ zIndex: 999, display: 'flex', position: 'absolute', top: '78%', left: '0%', right:'0%', justifyContent:'space-around', width: '100%' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '0 5px', width: '30%' }}>
          <button id="globe-btn-location" onMouseEnter={() => handleRotation(355, 65, 1)}>
            IL, USA
          </button>
          <span className="address">1793 Bloomingdale Rd, Glendale Heights, IL 60139, USA.</span>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '0 5px', width: '30%' }}>
          <button id="globe-btn-location" onMouseEnter={() => handleRotation(140, 58, 2)}>
            Dubai, UAE 
          </button>
          <span className="address">Level 23, Boulevard plaza Tower,2 Shaikh Mohammad bin Rashid Blvd-Dubai.</span>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '0 5px', width: '30%' }}>
          <button id="globe-btn-location" onMouseEnter={() => handleRotation(160, 60, 3)}>
            Karachi, Pakistan
          </button>
          <span className="address">B-803 & 804, 8th Floor Fortune Tower, Shahrah-e-Faisal Karachi.</span>
        </div>
      </div>
      
   
      <Canvas style={{pointerEvents:'none'}} camera={{ position: [0, 0, 5], fov: cameraFov }}>
        <ambientLight intensity={1} />
        <Model selectedVal={selectedVal} globeSize={globeSize} position={[0, 0.1, 0]} />
        <Environment preset="city" />
        <ContactShadows frames={1} scale={5} position={[0, -1, 0]} far={1} blur={5} opacity={0.5} color="#204080" />
        <CustomOrbitalControl azAngle={earthazAngle} plAngle={earthplAngle} />
      </Canvas>
     
      
    </>
  )
}
